var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Route',{staticClass:"MainLogo",attrs:{"exact":true,"title":"Pagrindinis","to":"Index"}},[_c('Pic',{attrs:{"alt":"Saulės Bendruomenė","src":"../../assets/logo.svg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }